import React from "react";
import { Tab, Nav } from "react-bootstrap";
import {
  FaRegUser,
  FaIdBadge,
  FaMobileAlt,
  FaUsers,
  FaCheckCircle,
  FaBuilding,
} from "react-icons/fa";
import adminDashboard from "../Images/dashboards/admin-dashboard.png";
import hrDashboard from "../Images/dashboards/hr-dashboard.png";
import employeeDashboard from "../Images/dashboards/employee-dashboard.png";
import multiCompanyDashboard from "../Images/dashboards/multi-company-dashboard.png";
import "./slider.css";

const dashboards = [
  {
    key: "admin",
    label: "Admin Dashboard",
    icon: FaRegUser,
    image: adminDashboard,
    alt: "BillPunch admin dashboard",
    description:
      "Get a bird's-eye view of all your HR operations across companies.",
    benefits: [
      "Real-time workforce insights",
      "Attendance and leave overview",
      "Payroll and expense tracking",
      "Multi-firm control from one place",
      "Customizable reports and charts",
    ],
  },
  {
    key: "hr",
    label: "HR Dashboard",
    icon: FaIdBadge,
    image: hrDashboard,
    alt: "BillPunch HR dashboard",
    description:
      "Keep your people, policies and day-to-day HR tasks organized in one place.",
    benefits: [
      "Centralized employee information",
      "Attendance and leave management",
      "Manage employee requests",
      "Payroll and expense overview",
      "Reports for your HR team",
    ],
  },
  {
    key: "employee",
    label: "Employee Dashboard",
    icon: FaMobileAlt,
    image: employeeDashboard,
    alt: "BillPunch employee dashboard",
    description:
      "Give employees easy access to the information and tools they need.",
    benefits: [
      "Personal attendance overview",
      "Apply for leave and track requests",
      "Access payroll information",
      "Submit and track expenses",
      "Employee self-service tools",
    ],
  },
  {
    key: "companies",
    label: "Multi-Company View",
    icon: FaUsers,
    image: multiCompanyDashboard,
    alt: "BillPunch multi-company dashboard",
    description:
      "Manage your firms, branches and workspaces with centralized visibility and control.",
    benefits: [
      "Manage multiple companies",
      "Separate company workspaces",
      "Company-specific roles and policies",
      "Oversee teams across locations",
      "Centralized reporting and insights",
    ],
  },
];

const Slider = () => (
  <section
    id="slider"
    className="billpunch-overview"
    aria-labelledby="billpunch-overview-title"
  >
    <div className="billpunch-overview__inner">
      <header className="billpunch-overview__heading">
        {/* <span className="billpunch-overview__label">Product Overview</span> */}
        <h2 id="billpunch-overview-title">
          A Complete HRMS for Your Growing Business
        </h2>
        <p>
          From attendance to payroll, everything you need to manage your
          workforce efficiently —<br className="billpunch-overview__break" />{" "}
          with powerful multi-firm capabilities.
        </p>
      </header>
      <Tab.Container id="billpunch-overview-tabs" defaultActiveKey="admin">
        <Nav
          variant="pills"
          className="billpunch-overview__tabs"
          aria-label="Product dashboards"
        >
          {dashboards.map(({ key, label, icon: Icon }) => (
            <Nav.Item key={key}>
              <Nav.Link as="button" type="button" eventKey={key}>
                <Icon aria-hidden="true" />
                <span>{label}</span>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <Tab.Content>
          {dashboards.map(({ key, description, benefits, image, alt }) => (
            <Tab.Pane key={key} eventKey={key}>
              <div className="billpunch-overview__layout">
                <aside className="billpunch-overview__benefits">
                  <p>{description}</p>
                  <ul>
                    {benefits.map((benefit) => (
                      <li key={benefit}>
                        <FaCheckCircle aria-hidden="true" />
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </aside>
                <div className="billpunch-overview__preview">
                  {key === "companies" && (
                    <div className="billpunch-overview__company-caption">
                      <FaBuilding aria-hidden="true" />
                      <span>
                        One platform for your companies, branches and teams
                      </span>
                    </div>
                  )}
                  <img src={image} alt={alt} loading="lazy" />
                </div>
              </div>
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    </div>
  </section>
);

export default Slider;
